"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const aws_amplify_1 = require("aws-amplify");
const auth_1 = require("aws-amplify/auth");
const cognito_1 = require("aws-amplify/auth/cognito");
class GolfGuruAuthClient {
    constructor({ userPoolId, userPoolWebClientId }) {
        aws_amplify_1.Amplify.configure({
            Auth: {
                Cognito: {
                    userPoolId,
                    userPoolClientId: userPoolWebClientId,
                    loginWith: {
                        username: true,
                        email: false,
                    },
                },
            },
        });
    }
    login({ email, password }) {
        return (0, auth_1.signIn)({
            username: email,
            password,
        });
    }
    signUp({ email, password, firstName, lastName, }) {
        return (0, auth_1.signUp)({
            username: email,
            password,
            options: {
                userAttributes: {
                    given_name: firstName,
                    family_name: lastName,
                },
                autoSignIn: false,
            },
        });
    }
    confirm({ email, code, group }) {
        return (0, auth_1.confirmSignUp)({
            username: email,
            confirmationCode: code,
            options: {
                clientMetadata: {
                    group,
                },
            },
        });
    }
    resendVerification({ email }) {
        return (0, auth_1.resendSignUpCode)({
            username: email,
        });
    }
    refresh() {
        return __awaiter(this, void 0, void 0, function* () {
            yield (0, auth_1.fetchAuthSession)();
            return this.getTokens();
        });
    }
    forgotPassword({ email }) {
        return (0, auth_1.resetPassword)({
            username: email,
        });
    }
    forgotPasswordSubmit({ email, code, password }) {
        return (0, auth_1.confirmResetPassword)({
            username: email,
            confirmationCode: code,
            newPassword: password,
        });
    }
    getUserGroups() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const tokens = yield this.getTokens();
            return (_a = tokens === null || tokens === void 0 ? void 0 : tokens.accessToken) === null || _a === void 0 ? void 0 : _a.payload['cognito:groups'];
        });
    }
    logout() {
        return (0, auth_1.signOut)();
    }
    getTokens() {
        return cognito_1.cognitoUserPoolsTokenProvider.getTokens();
    }
    getAttributes() {
        return (0, auth_1.fetchUserAttributes)();
    }
}
exports.default = GolfGuruAuthClient;
